import CardAnalysis from './CardAnalysis';

export default CardAnalysis;
